
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  CircularProgress,
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiUrl from '../../Config';

const DisplayTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  const getAllTestimonials = async () => {
    setLoading(true)
    try {
      // await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await axios.get(`${apiUrl}/testimonials/getalltestimonial`);
      setTestimonials(response.data.getAllTestimonials);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getAllTestimonials();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/testimonials/deletetestimonial/${id}`);
      getAllTestimonials();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box p={2} mt={2}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5">Testimonials</Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => navigate('/create-edit-testimonials')}
        >
          Add New
        </Button>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={200}>
          <CircularProgress />
        </Box>
      ) : (
         <Grid container spacing={3}>
        {testimonials?.map((testimonial) => (
          <Grid  size={{xs:12, sm:6, md:4}} key={testimonial.id}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              {testimonial.imageUrl && (
                <CardMedia
                  component="img"
                  height="180"
                  width={'60% !important'}
                  image={testimonial.imageUrl}
                  alt="testimonial"
                  sx={{ objectFit: 'contain !important' }}
                />
              )}
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6">{testimonial.name}</Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  {testimonial.designation}
                </Typography>
                <Typography variant="body2" mt={1}>
                  {testimonial.description}
                </Typography>
              </CardContent>
              <CardContent sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <IconButton
                  color="primary"
                  onClick={() =>
                    navigate('/create-edit-testimonials', {
                      state: { testimonial },
                    })
                  }
                >
                  <Edit />
                </IconButton>
                <IconButton color="error" onClick={() => handleDelete(testimonial.id)}>
                  <Delete />
                </IconButton>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      )}
    </Box>
  );
};

export default DisplayTestimonials;
